var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChild = function SvgChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1 72c0-39.76 33.1-72 72-72 40.7 0 72 32.24 72 72 0 39.8-31.3 72-72 72-38.9 0-72-32.2-72-72zm72 24c14.2 0 24-10.75 24-24s-9.8-24-24-24c-12.4 0-24 10.75-24 24s11.6 24 24 24zM128 384v104c0 13.3-10.7 24-24 24-13.25 0-24-10.7-24-24V257.9l-36.34 51.9c-7.61 10.8-22.58 13.5-33.43 5.9-10.857-7.7-13.489-22.6-5.881-33.5L50.1 216.1c25.02-34.8 65-57 109.5-57 43.1 0 83.6 21.7 108.7 56l47.2 66.9c7.7 10.8 5.2 25.8-6.4 33.5-9.9 7.7-24.9 5.2-32.6-5.6l-36.5-51V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-64zm0-48h64V214.4c-10.2-4.2-21.2-6.4-32.4-6.4-11 0-21.7 2.1-31.6 6v122z"
  })));
};

export default SvgChild;